// extracted by mini-css-extract-plugin
export default {"content_dt":"Buscas_content_dt__8by9j","content_dtfilmes":"Buscas_content_dtfilmes__LmTgH","wrapper":"Buscas_wrapper__EYTDo"};